import React, { useEffect, useState } from 'react';
import { blogList } from '../../api/apiHandler';
import { encryption } from '../../common/enc_dec';
import { Link } from 'react-router-dom';
import { Loading } from '../../components/loading/loading';
import ReactPaginate from "react-paginate";
import { useTranslation } from 'react-i18next';
import '../../i18';

const Blog = () => {
    const { t } = useTranslation();

    const [blogs, setBlogs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [pageToken, setPageToken] = useState(1);
    const [totalPage, setTotalPage] = useState('');

    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
            await getBlogList();
        };
        setIsLoading(false)
        fetchData();
    }, [pageToken]);

    const getBlogList = async () => {
        const response = await blogList(
            {
                page: pageToken,
                limit: 6
            }
        );
        if (response?.code === 200) {
            setBlogs(response?.data?.data);
            setTotalPage(response.data.paging);
        }
    }

    const handlePageClick = (e) => {
        setPageToken(e.selected + 1)
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <>
            <div className="course-single-area pd-top-120 pd-bottom-90 bgBrown">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="PageTitleBox pb-0">
                                <h2 className="PageTitleHeading">{t('blogsHeading')}</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {blogs?.length > 0 ? (
                            blogs.map((blog, index) => (
                                <div className="col-lg-4 col-md-6 CourseGride" key={index}>
                                    <div className="single-course-inner">
                                        <Link to={`/blog-details/${encodeURIComponent(encryption({ blog_id: blog.id }, true))}`} className="thumb">
                                            <img src={blog.image || process.env.PUBLIC_URL + "/assets/img/course/default.png"} alt={blog.title} />
                                        </Link>
                                        <div className="details">
                                            <Link to={`/blog-details/${encodeURIComponent(encryption({ blog_id: blog.id }, true))}`} className="details-inner BlogCardBody">
                                                <p className="CardMainHeading">{blog?.blog_category?.name}</p>
                                                <h6 className="CardMainSubHeading">{blog.title}</h6>
                                                <p className="CardContent text-truncate-2">{blog.description}</p>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p>{t('noBlogs')}</p>
                        )}
                        <ReactPaginate
                            className='pagination mt-4'
                            breakLabel="..."
                            nextLabel={`${t('next')} >`}
                            previousLabel={`< ${t('Previous')} `}
                            renderOnZeroPageCount={null}
                            onPageChange={handlePageClick}
                            pageCount={Math.ceil(totalPage.total / totalPage.page_limit)}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Blog;